<template>
  <div class="out-index">
    <div class="title">
      <span>支出列表</span>
      <mu-button class="add-btn" color="purple" @click="addOpen = true">
        <mu-icon value="add" :size="20"></mu-icon>
        新增支出
      </mu-button>
    </div>
    <mu-paper :z-depth="1" class="search-area">
      <mu-form :model="form" label-width="80" class="form" :inline="true">
        <mu-form-item prop="search" label="搜索" label-position="left">
          <mu-text-field
            v-model="form.keyword"
            help-text="请输入支出名称"
          ></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="userId" label="支出人" label-position="left">
          <mu-select v-model="form.userId">
            <mu-option
              v-for="(user, index) in userList"
              :key="index"
              :label="user.realName"
              :value="user.id"
            ></mu-option>
          </mu-select>
        </mu-form-item>
        <mu-form-item prop="search" label="开始时间" label-position="left">
          <mu-date-input container="dialog" v-model="form.startTime"></mu-date-input>
        </mu-form-item>
        <mu-form-item prop="search" label="结束时间" label-position="left">
          <mu-date-input container="dialog" v-model="form.endTime"></mu-date-input>
        </mu-form-item>
        <mu-form-item prop="outCategoryId" label="分类" label-position="left">
          <mu-select v-model="form.outCategoryId">
            <mu-option
              v-for="(category, index) in outCategoryList"
              :key="index"
              :label="category.name"
              :value="category.id"
            ></mu-option>
          </mu-select>
        </mu-form-item>
        <mu-form-item
          prop="onlyVerified"
          label="只看审核通过"
          label-position="left"
        >
          <mu-switch
            v-model="form.onlyVerified"
            :label="form.onlyVerified ? '是' : '否'"
          ></mu-switch>
        </mu-form-item>
      </mu-form>
      <div class="search-btn">
        <mu-button
          color="secondary"
          @click="download"
          v-loading="downloadLoading"
        >
          <mu-icon left value="archive" :size="20"></mu-icon>
          下载
        </mu-button>
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          搜索
        </mu-button>
      </div>
    </mu-paper>
    <div class="analysis">
      <mu-button fab color="indigo" large>
        {{ sum }}
      </mu-button>
    </div>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
      >
        <template slot-scope="scope">
          <td>{{ scope.row.name }}</td>
          <td>{{ scope.row.user.realName }}</td>
          <td>{{ moment(scope.row.createTime).format('YYYY-MM-DD HH:mm') }}</td>
          <td>
            {{
              `${scope.row.price} * ${scope.row.count}${scope.row.unit} = ${scope.row.sum}`
            }}
          </td>
          <td>{{ scope.row.outCategory.name }}</td>
          <td>
            <mu-button
              color="primary"
              @click="play(scope.row.record)"
              v-if="scope.row.record"
            >
              <mu-icon left value="record_voice_over"></mu-icon>
              播放
            </mu-button>
            <span v-else>无录音</span>
          </td>
          <td>
            <mu-button
              color="secondary"
              @click="viewImages(scope.row.images)"
              v-if="scope.row.images.length > 0"
            >
              <mu-icon left value="image"></mu-icon>
              查看
            </mu-button>
            <span v-else>无图片</span>
          </td>
          <td>{{ scope.row.status }}</td>
          <!-- <td>
            <mu-button color="info" @click="edit(scope.row)">
              <mu-icon left value="edit" :size="20"></mu-icon>
              编辑
            </mu-button>
            <mu-button color="secondary" @click="deleteOne(scope.row)">
              <mu-icon left value="delete" :size="20"></mu-icon>
              删除
            </mu-button>
          </td> -->
        </template>
      </mu-data-table>
    </mu-paper>
    <div class="page">
      <div class="info">共{{ total }}条记录</div>
      <mu-pagination
        raised
        :total="total"
        :current.sync="form.page"
        :page-size="15"
        @change="getAll"
      ></mu-pagination>
    </div>
    <Create :open.sync="addOpen" @finish="getAll()"></Create>
    <Update :open.sync="editOpen" :form="editForm" @finish="getAll()"></Update>
    <ImageView :open.sync="imageOpen" :imageList="imageList"></ImageView>
    <audio
      :src="audio"
      ref="audio"
      class="audio"
      controls
      @canplay="canPlay"
      @ended="playEnd"
      v-if="audio"
    ></audio>
  </div>
</template>

<script>
import Create from './create'
import Update from './update'
import ImageView from '@/components/imageView'
import backend from 'utils/backend'
import api from '@/api'
import moment from 'moment'
export default {
  components: { Create, Update, ImageView },
  data() {
    return {
      loading: false,
      addOpen: false,
      editOpen: false,
      editForm: {},
      imageOpen: false,
      imageList: [],
      form: {
        keyword: '',
        page: 1,
        relations: ['out.user', 'out.outCategory'],
        userId: 0,
        startTime: moment().startOf('month').toDate(),
        endTime: moment().endOf('month').toDate(),
        onlyVerified: false,
        outCategoryId: 0
      },
      total: 1,
      columns: [
        {
          title: '名称',
          name: 'name',
          align: 'center'
        },
        {
          title: '操作人',
          name: 'user',
          align: 'center',
          width: 120
        },
        {
          title: '时间',
          name: 'createTime',
          align: 'center'
        },
        {
          title: '单价 * 数量 = 总价',
          name: 'price',
          align: 'center'
        },
        {
          title: '分类',
          name: 'outCategory',
          align: 'center',
          width: 120
        },
        {
          title: '音频',
          name: 'record',
          align: 'center',
          width: 140
        },
        {
          title: '图片',
          name: 'images',
          align: 'center',
          width: 140
        },
        {
          title: '状态',
          name: 'status',
          align: 'center',
          width: 120
        }
        // {
        //   title: '操作',
        //   align: 'center',
        //   width: 400
        // }
      ],
      list: [],
      userList: [],
      audio: '',
      moment,
      sum: 0,
      downloadLoading: false,
      outCategoryList: []
    }
  },
  methods: {
    edit(item) {
      this.editForm = item
      this.editOpen = true
    },
    deleteOne(item) {
      this.$confirm('确定要删除？', '提示', {
        type: 'warning'
      }).then(({ result }) => {
        if (result) {
          backend(api.out.delete, { id: item.id }).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('删除成功')
              this.getAll()
            }
          })
        }
      })
    },
    getAll() {
      this.loading = true
      backend(api.out.getAll, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.loading = false
          this.list = result.data.rows
          this.total = result.data.count
          this.sum = result.data.sum.toFixed(2)
        }
      })
    },
    play(record) {
      this.audio = record
    },
    canPlay() {
      this.$refs.audio.play()
    },
    playEnd() {
      this.audio = ''
    },
    viewImages(images) {
      this.imageList = images
      this.imageOpen = true
    },
    getAllClerk() {
      backend(api.user.getAll, { getAll: true, isClerk: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.userList = [{ id: 0, realName: '全部' }, ...result.data.rows]
          }
        }
      )
    },
    download() {
      this.downloadLoading = true
      backend(api.out.getExcel, this.form).then((result) => {
        this.downloadLoading = false
        if (result.statusCode === 200) {
          window.open(result.data.url, '_blank')
        }
      })
    },
    getOutCategory() {
      backend(api.outcategory.getAll, { getAll: true }).then((result) => {
        if (result.statusCode === 200) {
          this.outCategoryList = [
            { id: 0, name: '全部分类' },
            ...result.data.rows
          ]
        }
      })
    }
  },
  mounted() {
    this.getAll()
    this.getAllClerk()
    this.getOutCategory()
  }
}
</script>

<style lang="less" scoped>
.out-index {
  position: relative;
  .search-area {
    padding: 12px;
    .search-btn {
      display: block;
      margin-top: 10px;
      border-top: 1px dashed #ddd;
      padding-top: 10px;
      display: flex;
      flex-direction: row-reverse;
    }
  }
  .analysis {
    position: absolute;
    right: 20px;
    top: 40px;
  }
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .table {
    margin-top: 20px;
    td {
      text-align: center;
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-right: 10px;
    }
  }
  .audio {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/out/index.vue